module.exports = __webpack_public_path__ + "static/media/background-2400.830acfce.jpg";